import React, {Key, MouseEventHandler, useState} from "react";
import {useDeviceSelectors} from "react-device-detect";
import {DataTablesSchema} from "@commons/mapping/DataTablesSchema";

export type FClassName = () => string | undefined;

interface BodyRowsRegister {
    key: Key;
    trClassName?: string | undefined | FClassName;
    className?: string | undefined;
    onMouseEnter: MouseEventHandler<HTMLTableRowElement>;
    onMouseLeave: MouseEventHandler<HTMLTableRowElement>;
}

interface BodyRowsRenderPropArg<T> {
    item: T;
    index: number;

    currentURI?: string | null;

    currentRow: number | null;
    setCurrentRow: (row: number | null) => void;

    register: (key: Key, index: number, selected?: boolean, className?: string) => BodyRowsRegister;

    isMobile: boolean;
}

interface DTTableProps<T> {
    dtSchema: DataTablesSchema<T> | undefined;
    currentURI?: string | null;
    classSelectedRow?: string;
    classEvenRows?: string;
    classOddRows?: string;
    header?: React.ReactNode;
    rows: React.ReactNode | ((arg: BodyRowsRenderPropArg<T>) => React.ReactNode);
    addTBody?: boolean
    isFetching?: boolean
    filter?: (arg: T) => boolean
}

// https://wanago.io/2020/03/09/functional-react-components-with-generic-props-in-typescript/
function DTTable<T>(props: DTTableProps<T>) {
    const [selectors] = useDeviceSelectors(window.navigator.userAgent)
    const {isMobile, mobileVendor} = selectors;
    const [currentRow, setCurrentRow] = useState<number | null>(null);
    const classSelectedRow = props.classSelectedRow ? props.classSelectedRow : 'bg-red-100';
    const classEvenRows = props.classEvenRows ? props.classEvenRows : 'bg-gray-100';
    const classOddRows = props.classOddRows ? props.classOddRows : undefined;
    const addTBody = props.addTBody ? props.addTBody : true;
    const filter = props.filter ? props.filter : ((arg: T) => true);

    function register(key: Key, index: number, selected?: boolean, userClassName?: string): BodyRowsRegister {
        let className = (index % 2 === 0) ? classOddRows : classEvenRows;
        //console.log(className);
        /*let trClassName;
        if (selected) {
            trClassName = () => selected() ? classSelectedRow : className;
        } else
            trClassName = className;*/
        className = (selected ? classSelectedRow : className) + ' ' + userClassName;
        return {
            key,
            className,
            onMouseEnter: () => setCurrentRow(index),
            onMouseLeave: () => setCurrentRow(null)
        };
    }

    return (
        /*<div className="flex flex-col">*/
            <div className="mt-2 overflow-x-auto shadow ring-1 ring-black ring-opacity-5 rounded-t-lg">
                <div className="inline-block min-w-full align-middle">
                    <div className="overflow-hidden rounded-t-lg">
                        <table className="min-w-full divide-y divide-gray-300">
                            <thead className="bg-gray-50">
                            {props.header && <tr>{props.header}</tr>}
                            </thead>
                            <tbody className="bg-white">
                            {
                                props.dtSchema && props.dtSchema.data && props.dtSchema.data.filter(filter).map((item, index) => {
                                    if (props.rows && (typeof props.rows === 'function')) {
                                        return props.rows({item, index, isMobile, currentRow, setCurrentRow, register});
                                    } else
                                        return props.rows;
                                })
                            }
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        /*</div>*/
    )
}

const DTTableEx: React.FC<DTTableProps<any>> = (props) => {
    return <>{props.dtSchema && <DTTable<typeof props.dtSchema.data[0]> {...props}></DTTable>}</>
}
export default DTTable;